<template>
  <!-- 成员选择树形结构 -->
  <el-popover placement="bottom" v-model="visible">
    <div class="zs-member-select">
      <div class="zs-member-select__left">
        <member-tree
          ref="memberTree"
          :show-checkbox="false"
          @node-click="nodeClick"
          @check="treeChange"
        ></member-tree>
      </div>
      <div class="zs-member-select__right">
        <el-checkbox-group v-model="checkedMember">
          <el-checkbox
            v-for="item in memberList"
            :label="item.id"
            :key="item.id"
            @change="(val) => memberChange(item, val)"
          >
            {{ item.text }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <!-- <el-select
      placeholder="选择成员"
      v-model="displayText"
      :size="size"
      readonly
      slot="reference"
      :style="width ? `width:${width}` : ''"
    ></el-select> -->
    <!-- 成员选择 -->
    <zs-custom-select
      v-model="displayText"
      class="w100"
      slot="reference"
      :divWidth="width"
      @handleDelete="deleteMember"
      :needSearch="false"
      :disabled="false"
    ></zs-custom-select>
  </el-popover>
</template>

<script>
import memberTree from './memberTree.vue'
import zsCustomSelect from '@/components/zsCustomSelect'
export default {
  name: 'member-select-by-tree',
  components: {
    memberTree,
    zsCustomSelect
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: 'small'
    },
    width: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      displayText: [],
      memberList: [],
      checkedMember: [],
      checkedRecord: {},
      timer: null,
      count: 0
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      if (
        this.$refs.memberTree &&
        this.$refs.memberTree.memberList.length > 0 &&
        this.count < 10
      ) {
        this.count++
        clearInterval(this.timer)

        this.value.forEach((t) => {
          const member = this.$refs.memberTree.memberList.find(
            (x) => x.id === t
          )
          if (member) {
            this.checkedRecord[t] = member.text
            if (!this.displayText.length) {
              this.displayText = [this.checkedRecord[t]]
            } else {
              this.displayText = [
                ...this.displayText,
                this.checkedRecord[t]
              ]
            }
          }
        })
      }
    }, 300)
  },
  deactivated() {
    this.timer && clearInterval(this.timer)
  },
  methods: {
    nodeClick(data) {
      this.memberList =
        (data.children && data.children.filter((t) => t.type === 1)) || []
      this.checkedMember = []
      for (const key in this.checkedRecord) {
        if (Object.hasOwnProperty.call(this.checkedRecord, key)) {
          if (this.checkedRecord[key]) {
            this.checkedMember.push(key)
          }
        }
      }
    },
    memberChange(item, val) {
      this.checkedRecord[item.id] = val && item.text
      this.displayText = []
      const value = []
      // 每次变化重新计算结果
      for (const key in this.checkedRecord) {
        if (Object.hasOwnProperty.call(this.checkedRecord, key)) {
          if (this.checkedRecord[key]) {
            if (!this.displayText.length) {
              this.displayText = [this.checkedRecord[key]]
            } else {
              this.displayText = [
                ...this.displayText,
                this.checkedRecord[key]
              ]
            }
            value.push(key)
          }
        }
      }
      this.$emit('input', value)
    },
    treeChange() {
      const checkList = this.$refs.memberTree.getInstance().getCheckedNodes()
      checkList
        .filter((t) => t.type === 1)
        .forEach((item) => {
          this.memberChange(item, true)
        })
    },
    deleteMember(row, index) {
      this.displayText.splice(index, 1)
      for (const key in this.checkedRecord) {
        if (Object.hasOwnProperty.call(this.checkedRecord, key)) {
          if (this.checkedRecord[key] === row) {
            const index = this.checkedMember.indexOf(key)
            if (index > -1) {
              this.checkedMember.splice(index, 1)
            }
          }
        }
      }
      this.$emit('input', this.checkedMember)
    }
  }
}
</script>

<style lang="scss">
.zs-member-select {
  display: flex;
  flex-direction: row;
  .zs-member-select__left {
    min-width: 150px;
    margin-right: 10px;
  }
  .zs-member-select__right {
    min-width: 150px;
    border-left: 1px solid rgba(0, 0, 0, 0.05);
    padding: 0 20px;
    box-sizing: border-box;
    .el-checkbox-group {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
